/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./FeedbackButton.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Button_1 = require("./Button");
var Spinner_1 = require("./Spinner");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-feedbackButton");
var AnimationError = /** @class */ (function () {
    function AnimationError(errMessage) {
        this.message = errMessage;
        this.error = new Error(errMessage);
    }
    return AnimationError;
}());
var FeedbackButton = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackButton, _super);
    function FeedbackButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wasUnmounted = false;
        _this.isAnimating = false;
        _this.responseType = "SUCCESS";
        _this.state = {
            animationState: "initial"
        };
        _this.onClick = function (e) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, onAnimationFinished, _d, onAnimationStateChange, _e, minSpinnerTime, shouldContinueAfterFeedback, result, animationState, err_1;
                return tslib_1.__generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            e.persist();
                            e.preventDefault();
                            /* Don't do anything during the animation */
                            if (this.isAnimating) {
                                return [2 /*return*/];
                            }
                            /* Don't start the animation when in almostActive state */
                            if (this.props.almostActive) {
                                (_a = this.props).onClick.apply(_a, [e].concat(args));
                                return [2 /*return*/];
                            }
                            /* Don't start the animation when in button disabled */
                            if (this.props.disabled) {
                                return [2 /*return*/];
                            }
                            _f.label = 1;
                        case 1:
                            _f.trys.push([1, 12, , 13]);
                            _c = this.props, onAnimationFinished = _c.onAnimationFinished, _d = _c.onAnimationStateChange, onAnimationStateChange = _d === void 0 ? function () { } : _d, _e = _c.minSpinnerTime, minSpinnerTime = _e === void 0 ? 2000 : _e, shouldContinueAfterFeedback = _c.shouldContinueAfterFeedback;
                            this.isAnimating = true;
                            return [4 /*yield*/, this.setStateAsync({ animationState: "beforeWaiting" })];
                        case 2:
                            _f.sent();
                            onAnimationStateChange("beforeWaiting");
                            return [4 /*yield*/, this.wait(100)];
                        case 3:
                            _f.sent();
                            this.responseType = "SUCCESS";
                            return [4 /*yield*/, this.setStateAsync({ animationState: "waiting" })];
                        case 4:
                            _f.sent();
                            onAnimationStateChange("waiting");
                            return [4 /*yield*/, Promise.all([
                                    (_b = this.props).onClick.apply(_b, [e].concat(args)),
                                    this.wait(minSpinnerTime)
                                ])];
                        case 5:
                            result = _f.sent();
                            if (result[0] === "ERROR") {
                                this.responseType = "ERROR";
                            }
                            animationState = this.responseType.toLowerCase();
                            return [4 /*yield*/, this.setStateAsync({
                                    animationState: animationState
                                })];
                        case 6:
                            _f.sent();
                            onAnimationStateChange(animationState);
                            return [4 /*yield*/, this.wait(2000)];
                        case 7:
                            _f.sent();
                            if (!(shouldContinueAfterFeedback === undefined ||
                                shouldContinueAfterFeedback(this.responseType))) return [3 /*break*/, 11];
                            return [4 /*yield*/, this.setStateAsync({ animationState: "afterFeedback" })];
                        case 8:
                            _f.sent();
                            onAnimationStateChange("afterFeedback");
                            return [4 /*yield*/, this.wait(800)];
                        case 9:
                            _f.sent();
                            this.isAnimating = false;
                            return [4 /*yield*/, this.setStateAsync({ animationState: "initial" })];
                        case 10:
                            _f.sent();
                            onAnimationStateChange("initial");
                            _f.label = 11;
                        case 11:
                            if (onAnimationFinished) {
                                onAnimationFinished(this.responseType);
                            }
                            return [3 /*break*/, 13];
                        case 12:
                            err_1 = _f.sent();
                            if (err_1 instanceof AnimationError) {
                                /* Safe to ignore: Was thrown when component was unmounted during animation */
                                return [2 /*return*/];
                            }
                            throw err_1;
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        return _this;
    }
    /* Promisified setState */
    FeedbackButton.prototype.setStateAsync = function (state) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.wasUnmounted) {
                reject(new AnimationError("Cant set state of unmounted component"));
            }
            else {
                _this.setState(state, resolve);
            }
        });
    };
    /* Promisified setTimeout */
    FeedbackButton.prototype.wait = function (ms) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return window.setTimeout(function () {
                if (_this.wasUnmounted) {
                    return reject(new AnimationError("Component was unmounted"));
                }
                resolve();
            }, ms);
        });
    };
    FeedbackButton.prototype.componentDidMount = function () {
        this.wasUnmounted = false;
    };
    FeedbackButton.prototype.componentWillUnmount = function () {
        this.wasUnmounted = true;
    };
    FeedbackButton.prototype.renderAnimation = function () {
        var _a = this.props, children = _a.children, errorFeedback = _a.errorFeedback, successFeedback = _a.successFeedback;
        var animationState = this.state.animationState;
        var renderFeedbackLabel = animationState === "error" ||
            animationState === "success" ||
            animationState === "waiting" ||
            animationState === "afterFeedback";
        return (React.createElement("div", { className: classnames(moduleClassName("animation"), propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), animationState)) },
            React.createElement("span", { className: moduleClassName("label") }, children),
            React.createElement("div", { className: moduleClassName("spinner") },
                React.createElement(Spinner_1.Spinner, null)),
            renderFeedbackLabel && (React.createElement("div", { className: moduleClassName("feedbackLabel") },
                this.responseType === "SUCCESS" && successFeedback,
                this.responseType === "ERROR" && errorFeedback))));
    };
    FeedbackButton.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, children = _a.children, block = _a.block, size = _a.size, className = _a.className, 
        // Do not handover props which are not supported from the Button
        errorFeedback = _a.errorFeedback, successFeedback = _a.successFeedback, minSpinnerTime = _a.minSpinnerTime, onAnimationFinished = _a.onAnimationFinished, onAnimationStateChange = _a.onAnimationStateChange, shouldContinueAfterFeedback = _a.shouldContinueAfterFeedback, props = tslib_1.__rest(_a, ["onClick", "children", "block", "size", "className", "errorFeedback", "successFeedback", "minSpinnerTime", "onAnimationFinished", "onAnimationStateChange", "shouldContinueAfterFeedback"]);
        /* Stunt-Double approach: use normal component by default,
         * render a simplified, animation-only variant on top of
         * it for animation */
        return (React.createElement("div", { className: classnames(moduleClassName(), block && moduleClassName("isBlock"), size && propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), size), className) },
            React.createElement(Button_1.Button, tslib_1.__assign({}, props, { block: block, onClick: this.onClick, onSubmit: this.onClick, size: size, className: className }), children),
            this.isAnimating && this.renderAnimation()));
    };
    FeedbackButton.propTypes = tslib_1.__assign({}, Button_1.Button.propTypes, { className: PropTypes.string, successFeedback: PropTypes.string.isRequired, errorFeedback: PropTypes.string.isRequired, 
        /**
         * The minimum time in ms that the Spinner should be shown
         * @default 2000
         */
        minSpinnerTime: PropTypes.number, 
        /**
         * Should return a Promise that resolves to either 'SUCCESS' or 'ERROR'
         */
        onClick: PropTypes.func.isRequired, 
        /**
         * Gets called every time, after the feedback animation finished,
         * @param {FeedbackButtonResponseType} type The responseType that it showed ("SUCCESS" or "ERROR")
         */
        onAnimationFinished: PropTypes.func, 
        /**
         * Gets called every time, the animation state changes,
         * @param {FeedbackButtonAnimationState} animationState The current state of the animation
         */
        onAnimationStateChange: PropTypes.func, 
        /**
         * Gets called during the animation and lets the application decide,
         * if the button should go back into its initial state.
         * @param {FeedbackButtonResponseType} type The responseType that it showed ("SUCCESS" or "ERROR")
         * @returns {Boolean} true or false
         */
        shouldContinueAfterFeedback: PropTypes.func });
    return FeedbackButton;
}(React.Component));
exports.FeedbackButton = FeedbackButton;